import { render, staticRenderFns } from "./get-dialog.vue?vue&type=template&id=a7015358&"
import script from "./get-dialog.vue?vue&type=script&lang=js&"
export * from "./get-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports